module.exports = __webpack_public_path__ + "img/Accounting-256.19d8fa6d.png";